import { render, staticRenderFns } from "./ProjectBox.vue?vue&type=template&id=c455683a&scoped=true"
import script from "./ProjectBox.vue?vue&type=script&lang=js"
export * from "./ProjectBox.vue?vue&type=script&lang=js"
import style0 from "./ProjectBox.vue?vue&type=style&index=0&id=c455683a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c455683a",
  null
  
)

export default component.exports